import React, { useEffect, useState } from 'react'
import {Link, NavLink, useNavigate} from 'react-router-dom'
import {DASHBOARD_SIDEBAR_LINKS } from "../../lib/const/navigation";
import { useStateContext } from '../../context/ContextProvider';
import logo from '../../assets/FIPVector.png'
const Sidebar = () => {

  const [userRole, setUserRole] =useState('')

  const navigate = useNavigate();


  useEffect(() => {

    // Retrieve user role from local storage
    const token = JSON.parse(localStorage.getItem('token'));
    setUserRole(token!=null?token.result.role:null);
    if(token===null || token.result.role === 'null'){
      navigate('/login')
      
    }
    // console.log('token role',token.result.role)
  }, []);


    const {activeMenu,setActiveMenu,screenSize} = useStateContext();
    const [subMenuOpen, setSubMenuOpen] = useState(false);

    const handleCloseSideBar = ()=>{
        if(activeMenu && screenSize <= 900){
            setActiveMenu(false)
            setSubMenuOpen(false)
        }
    }

    const handleSubMenuClick = (key) => {
    setSubMenuOpen(subMenuOpen === key ? false : key);
  };

    const renderSubMenu = (submenu) => (
      <div className='pl-4 py-3 bg-skin-sidebar-submenu'>
        {submenu.map((item) => (
          <NavLink
            key={item.key}
            to={item.path}
            onClick={handleCloseSideBar}
            className={({isActive})=>
                  isActive?activeSubmenuLink:normalSubmenuLink
                }>
            {item.icon}
            {item.label}
          </NavLink>
        ))}
      </div>
    );

    const activeLink = 'flex items-center pl-6 gap-4 py-4 rounded-lg text-skin-sidebar text-xl m-2 bg-skin-button justify-start font-semibold shadow-lg'
    const normalLink = 'flex items-center gap-5 pl-6 py-4 rounded-lg text-lg text-skin-sidebar hover:bg-skin-button  text-md m-2 font-semibold'
    
    const activeSubmenuLink = 'flex items-center pl-6 gap-4 py-3 rounded-lg text-skin-sidebar text-lg m-2 bg-skin-sidebar justify-start font-semibold shadow-lg'
    const normalSubmenuLink = 'flex items-center gap-4 pl-6 py-3 rounded-lg text-md text-skin-sidebar hover:bg-skin-sidebar  text-md m-2 font-semibold'


  return (
    <div className='h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10 bg-skin-sidebar z-40  bg-blur-lg shadow-lg '>
        {activeMenu &&(<>
        <div className='flex justify-start ml-6 items-center'>
          <Link to='/' onClick={handleCloseSideBar} className='items-center gap-3 mt-5 flex font-bold tracking-tight text-skin-sidebar text-2xl '>
          <img
            src={logo} 
            className={`cursor-pointer`}
            width={32} height={32}
            alt="pharma bi logo"
          />
            <span>PHARMA BI</span>
          </Link>
        </div>
        <div className='mt-10 gap-2 flex flex-col h-[85vh] overflow-scroll'>
              {DASHBOARD_SIDEBAR_LINKS[userRole]?.map((item,index)=>(
                <div key={index}>
                {item.submenu ? (
                  <>
                    <div
                      className='flex items-center gap-5 pl-6 py-4 rounded-lg text-lg text-skin-sidebar hover:bg-skin-button text-md m-2 font-semibold cursor-pointer'
                      onClick={() => handleSubMenuClick(item.key)}
                    >
                      {item.icon}
                      <span className='capitalize'>{item.label}</span>
                    </div>
                    {subMenuOpen === item.key && renderSubMenu(item.submenu)}
                  </>
                ):(
                <NavLink
                to={item.path}
                onClick={handleCloseSideBar}
                className={({isActive})=>
                  isActive?activeLink:normalLink

                }
                >
                  {item.icon}
                  <span className='capitalize '>{item.label}</span>

                </NavLink>
                )}
          
                <div className='h-[0.7px] mx-4 bg-green-500  opacity-40 bg-blur-lg rounded-lg'></div>
                </div>
              ))}


        </div>
      </>)}


    </div>
  )
}

export default Sidebar